import BootstrapVue from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'firebase/auth';
import Vue from 'vue';
import VueCarousel from 'vue-carousel';
import Chartist from 'vue-chartist';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VueToast from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-sugar.css';
import VueYouTubeEmbed from 'vue-youtube-embed';
import App from './app.vue';
import './assets/css/custom.css';
import { initAuthorization } from './auth';
import ExtendedApolloQuery from './components/shared/extendedApolloQuery.vue';
import addCustomFilters from './filters';
import loadI18n from './i18n';
import importIcons from './icons';
import router from './router';
import store from './store';
import { createProvider } from './vue-apollo';

importIcons();

// We put here some often-used common components that we dont want to load
// component by component

Vue.component('Loading', {
  extends: Loading,
  props: {
    loader: { type: String, default: 'dots' },
    canCancel: { type: Boolean, default: false },
    isFullPage: { type: Boolean, default: false },
  },
});

Vue.use(Loading, {
  loader: 'dots',
  canCancel: false,
  isFullPage: false,
});
Vue.use(VueToast);
Vue.use(VueYouTubeEmbed);

Vue.component('ExtendedApolloQuery', ExtendedApolloQuery);

Vue.use(Chartist);
Vue.use(VueCarousel);
Vue.config.productionTip = false;
Vue.use(BootstrapVue);

addCustomFilters();

const apolloProvider = createProvider();

initAuthorization(apolloProvider.defaultClient);

new Vue({
  i18n: loadI18n(),
  router,
  store,
  apolloProvider,
  render: (h) => h(App),
}).$mount('#app');
